var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _ellipse2, _path12, _ellipse3, _rect, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutomaticScan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 270,
    viewBox: "0 0 300 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7499_64278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 14,
    width: 230,
    height: 230
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.7,
    cy: 128.7,
    r: 114.7,
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7499_64278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.594 194.204L153.956 181.445L104.56 181.864L70.6693 193.161C58.0267 197.375 48.1459 207.357 44.0609 220.042L42.6052 224.562L141.388 255.493L215.074 236.283C215.074 236.283 221.64 239.723 209.641 214.175C205.272 204.872 197.204 197.85 187.594 194.204Z",
    fill: "white",
    stroke: "#424243",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.978 181.864C111.059 178.734 112.275 173.284 110.001 163.863L127.118 172.068L136.793 172.654L146.421 168.049C145.465 175.63 146.839 178.933 153.956 181.445C151.613 193.641 148.671 199.092 141.842 206.678C139.392 209.4 135.382 210.07 132.165 208.319C118.193 200.714 111.811 194.274 104.978 181.864Z",
    fill: "white",
    stroke: "#424243",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6017 112.793L89.7971 113.89L118.886 89.1921L166.636 104.011L167.733 111.146L166.636 124.318L165.538 128.709V134.746L163.343 146.272L158.403 156.152L147.975 167.128L135.9 173.166L126.021 172.068L107.36 162.189L98.0298 151.761L91.4437 134.746H85.9552L82.6621 124.318L83.7598 113.89L87.6017 112.793Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M209.446 117.808L140.561 171.817C127.104 171.817 112.3 161.091 105.713 152.31C86.6585 122.77 94.4356 72.5262 159.501 88.6432L209.446 99.0714V117.808Z",
    fill: "url(#paint0_linear_7499_64278)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.733 105.152C113.68 102.06 119.061 101.196 124.496 102.009C133.761 103.394 139.166 112.627 140.431 121.908L142.878 139.854C143.015 140.859 142.234 141.754 141.219 141.754H130.316",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.521 116.889C115.894 113.735 120.03 113.749 127.403 116.889",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.235 116.889C151.609 113.735 155.745 113.749 163.118 116.889",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.442 115.6C155.341 115.48 157.042 115.72 159.837 116.464L159.861 116.271C159.933 116.569 159.971 116.88 159.971 117.2C159.971 119.372 158.21 121.133 156.038 121.133C153.865 121.133 152.104 119.372 152.104 117.2C152.104 116.63 152.225 116.089 152.442 115.6Z",
    fill: "#424243"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.243 114.75C116.708 115.422 116.388 116.274 116.388 117.2C116.388 119.372 118.149 121.134 120.322 121.134C122.495 121.134 124.256 119.372 124.256 117.2C124.256 116.651 124.143 116.129 123.941 115.654C121.465 114.965 119.824 114.711 117.243 114.75Z",
    fill: "#424243"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.009 154.343C135.635 156.62 139.789 156.253 146.678 154.343",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4245 114.611C102.226 111.464 109.7 105.169 120.322 91.7944C133.697 101.629 147.859 105.956 163.201 109.103L169.888 109.89C166.348 76.0589 152.973 62.2904 125.829 60.3235C96.3253 64.6507 85.7039 82.3531 85.7039 112.644C88.141 112.18 88.8509 112.644 90.4245 114.611Z",
    fill: "#424243",
    stroke: "#424243",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.6736,
    cy: 88.7594,
    rx: 8.62348,
    ry: 11.8674,
    transform: "rotate(-35 93.6736 88.7594)",
    fill: "#424243"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.135 123.659L166.138 123.576L167.135 123.659ZM146.573 168.301L147.204 169.076L146.573 168.301ZM126.812 66.2443L126.872 65.2461L126.812 66.2443ZM123.95 170.947L124.369 170.04L123.95 170.947ZM92.5904 130.966C92.4984 130.422 91.9823 130.055 91.4378 130.147C90.8932 130.239 90.5264 130.755 90.6184 131.3L92.5904 130.966ZM84.5145 113.362L83.9781 112.518H83.9781L84.5145 113.362ZM83.1825 115.271L82.2279 114.973H82.2279L83.1825 115.271ZM86.1639 134.847L85.5988 135.672H85.5988L86.1639 134.847ZM166.138 123.576C165.084 136.306 163.165 144.712 159.974 151.208C156.793 157.684 152.306 162.347 145.942 167.525L147.204 169.076C153.671 163.814 158.406 158.935 161.769 152.09C165.122 145.265 167.069 136.571 168.131 123.741L166.138 123.576ZM126.751 67.2424C142.617 68.2059 153.129 72.9907 159.354 82.001C165.619 91.07 167.706 104.645 166.138 123.576L168.131 123.741C169.71 104.675 167.667 90.5164 160.999 80.8643C154.291 71.1535 143.068 66.2296 126.872 65.2461L126.751 67.2424ZM124.369 170.04C113.675 165.103 106.784 161.2 102.032 155.65C97.2997 150.124 94.5995 142.853 92.5904 130.966L90.6184 131.3C92.6489 143.313 95.4285 151.013 100.513 156.951C105.577 162.865 112.838 166.919 123.531 171.855L124.369 170.04ZM88.0117 112.653C88.131 99.6107 90.0653 87.7781 95.8014 79.4632C101.472 71.2434 110.987 66.2851 126.751 67.2424L126.872 65.2461C110.574 64.2564 100.309 69.4065 94.1551 78.3275C88.0667 87.1533 86.132 99.4941 86.0118 112.635L88.0117 112.653ZM90.8257 113.52C89.2914 111.511 86.3339 111.02 83.9781 112.518L85.051 114.206C86.6047 113.218 88.3836 113.617 89.2362 114.734L90.8257 113.52ZM82.2279 114.973C80.9106 119.194 80.9346 123.761 81.6548 127.524C82.0156 129.408 82.5561 131.12 83.2109 132.507C83.853 133.868 84.655 135.025 85.5988 135.672L86.729 134.022C86.2165 133.671 85.603 132.89 85.0197 131.654C84.4492 130.445 83.9544 128.899 83.6192 127.148C82.9475 123.638 82.9371 119.414 84.1371 115.569L82.2279 114.973ZM85.5988 135.672C88.7447 137.827 91.6959 135.559 92.4548 135.17L91.5409 133.391C90.2315 134.063 88.6566 135.342 86.729 134.022L85.5988 135.672ZM83.9781 112.518C83.0329 113.119 82.5062 114.082 82.2279 114.973L84.1371 115.569C84.3349 114.935 84.6478 114.462 85.051 114.206L83.9781 112.518ZM145.942 167.525C139.906 172.437 131.471 173.318 124.369 170.04L123.531 171.855C131.29 175.437 140.545 174.495 147.204 169.076L145.942 167.525Z",
    fill: "#424243"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.487,
    cy: 61.1104,
    rx: 16.5222,
    ry: 11.4082,
    transform: "rotate(-15 110.487 61.1104)",
    fill: "#424243"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 60.2515C110.726 60.4985 110.526 61.0992 110.773 61.5932C111.02 62.0872 111.621 62.2874 112.115 62.0404L111.22 60.2515ZM112.115 62.0404C115.872 60.1619 120.301 59.1431 127.122 59.1637L127.128 57.1637C120.09 57.1425 115.331 58.1962 111.22 60.2515L112.115 62.0404Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.5428,
    cy: 72.7347,
    rx: 11.9171,
    ry: 10.6503,
    transform: "rotate(-51.7823 95.5428 72.7347)",
    fill: "#424243"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 209.427,
    y: 90.0945,
    width: 38.5124,
    height: 77.8619,
    rx: 5.02335,
    fill: "#424243"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.102 167.363C218.006 174.583 219.384 179.81 221.116 182.982L221.149 183.042C222.308 185.164 223.586 187.504 223.262 189.895C221.349 204.017 214.491 216.42 208.589 225.306L240.73 222.562C242.393 211.193 244.923 199.013 246.683 185.957L251.043 143.947C251.201 142.418 250.834 140.878 249.972 139.607C242.845 129.1 233.977 119.092 230.302 116.086C228.166 114.338 225.907 113.083 223.607 112.137C220.45 110.839 218.297 115.186 220.755 117.554C224.867 121.514 227.661 124.64 228.655 125.965C233.225 132.058 235.672 135.753 239.567 142.84C231.83 135.89 226.007 131.018 217.678 125.965C214.599 124.487 211.728 123.296 208.698 122.346C205.494 121.341 203.805 125.249 206.433 127.34C210.349 130.455 214.389 133.798 219.055 137.816C223.166 141.61 225.922 144.723 231.195 151.631L210.154 141.382C208.926 140.784 207.456 141.44 207.081 142.754L206.487 144.837C206.24 145.703 206.55 146.634 207.264 147.183C218.086 155.497 221.465 158.307 223.66 160.84C217.724 157.872 214.387 156.415 210.012 154.773C208.82 154.325 207.502 154.999 207.154 156.224L206.535 158.395C206.265 159.345 206.662 160.358 207.505 160.872L214.554 165.162C215.293 165.612 215.83 166.333 216.051 167.17L216.102 167.363Z",
    fill: "white",
    stroke: "#424243",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.408 220.552V242.321H255V211.585H213.985C210.646 214.78 207.114 217.775 203.408 220.552Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7499_64278",
    x1: 139.193,
    y1: 59.5543,
    x2: 199.567,
    y2: 180.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916277,
    stopColor: "#C1E6FF",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutomaticScan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/automatic_scan.c4ce15fc7b36d125083726365468205b.svg";